import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModel } from '@angular/forms';
import { MaskitoOptions } from '@maskito/core';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { masks } from 'src/app/services/input-masks';
import { InterpolationService } from 'src/app/services/interpolation.service';
import { QuestionService } from 'src/app/services/question.service';

@Component({
  selector: 'app-numeric-question',
  templateUrl: './numeric-question.component.html',
  styleUrls: ['./numeric-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class NumericQuestionComponent implements OnInit {

  @Input() question: QQQuestionViewModel;
  @ViewChild('numeric') numeric: NgModel;
  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  value: string;
  mask: MaskitoOptions = null;
  length: number;
  isCurrency: boolean;
  placeholder: string;

  constructor(
    private interpolator: InterpolationService,
    private questionService: QuestionService
  ) {
  }

  ngOnInit() {
    this.length = this.question.options.maxRange;
    if (this.question.options.calculate
      || this.question.options.translate)
      this.setup();
    else
      this.value = this.question.answer;
    this.placeholder = this.question.options.placeholder || this.question.label;
    // this.generateNumberMask(this.length);
  }

  reset() {
    this.value = this.question.answer;
  }

  private setup() {
    let opts = this.questionService.getCalculatedOptions(this.question);
    this.value = this.question.answer || opts.initialValue || null;

    this.question.setAnswer(this.value, true);
    const translate = this.question.options.translate;
    if (translate) {
      this.question.options.translate = (value: any) => this.interpolator.interpolate(translate, { value });
    }
    if (this.question.options.mask) {
      this.mask = masks[this.question.options.mask];
      //this.mask.placeholder = this.question.label;
      this.isCurrency = this.question.options.isCurrency == true;
    }
  }

  async save() {
    this.resetPlaceholder();

    let opts = this.questionService.getCalculatedOptions(this.question);
    if (!this.value) {
      this.question.error = `Please enter your ${this.question.options.name ? this.question.options.name : this.question.label}`;
      this.numeric.control.setErrors({ 'custom': this.question.error });
      return;
    }
    this.value = this.value.replace(/\D+/g, '');
    if (this.length) {
      let regEx = new RegExp(`^\\d{${this.length}}$`);
      if (!regEx.test(this.value)) {
        this.question.error = `Please enter a valid ${this.length} digit number`;
      }
    }
    else if (opts.floor && opts.ceil) {
      if (parseFloat(this.value) < parseFloat(opts.floor))
        this.question.error = `Minimum ${opts.name ?? 'value'} is ${opts.floor}`;
      else if (parseFloat(this.value) > parseFloat(opts.ceil)) {
        this.question.error = `Maximum ${opts.name ?? 'value'} is ${opts.ceil}`;
      }
    }
    if (!this.question.error && !await this.question.setAnswer(this.value, true))
      this.question.error = this.question.error;

    if (this.question.error)
      this.numeric.control.setErrors({ 'custom': this.question.error });
  }

  resetPlaceholder() {
    setTimeout(() => this.input.nativeElement.placeholder = this.placeholder);
  }
}
